
export const types = {
  login: "[Auth] Login",
  logout: "[Auth] Logout",
  switchToUser: "[Auth] Switch to _idUser",
  restoreMaster: "[Auth] Restore master",
};
